module.exports = __webpack_public_path__ + "static/media/verbs_in_ui3.f5d0d47d.JPG";